import { Directive, HostListener, Input, OnDestroy } from '@angular/core';
import { ShellContextService } from 'app/services/shell-context/shell-context.service';
import { TimberService } from '@logging/timber.service';
import { take } from 'rxjs';
import { BiAction, BiObjectType, ExistingObjectIds } from '@logging/interfaces/bi.enums';
import { BiFeatureWrapperService } from '@logging/bi-feature-wrapper.service';
import { ApplicationNavigationService } from 'app/services/shell/application-navigation/application-navigation.service';

@Directive({
	selector: '[logClick]',
})
export class LogClickDirective implements OnDestroy {
	private timeoutId: any;

	constructor(
		private shellContextService: ShellContextService,
		private timberService: TimberService,
		private biFeatureWrapperService: BiFeatureWrapperService,
		private applicationNavigationService: ApplicationNavigationService
	) {}
	@Input() objectType: BiObjectType = BiObjectType.Button;
	@Input() action: BiAction = BiAction.Clicked;
	@Input() value!: string;
	@Input() automationId!: string;
	@Input() locationParentObject!: string;

	@HostListener('click', ['$event'])
	handleClick(event: MouseEvent) {
		const clickedElement = event.target as HTMLElement;
		this.shellContextService
			.getContext()
			.pipe(take(1))
			.subscribe((context) => {
				const orderId = context?.bizCtx?.orderId;
				const selectedValue = this.value ? this.value : orderId ? `orderId: ${orderId.toString()}` : null;
				const parentPage =
					this.applicationNavigationService.peekTransition()?.navigatedToAppId || this.biFeatureWrapperService.getCurrentPage();
				const automationId = this.automationId ? this.automationId : '';
				this.timberService.userActionEvent({
					locationParentObject: this.locationParentObject || parentPage,
					objectName: this.getElementId(clickedElement),
					objectType: this.objectType,
					action: this.action,
					selectedValue: selectedValue,
					automationId: automationId,
				});
			});
	}

	ngOnDestroy(): void {
		if (this.timeoutId) {
			clearTimeout(this.timeoutId);
		}
	}

	private getElementId(element: HTMLElement): string {
		let currentElement = element;

		while (currentElement) {
			if (currentElement.id) {
				const cleanId = currentElement.id.replace(/[-_]\d+$/, '');
				return this.replaceId(cleanId);
			}
			currentElement = currentElement.parentElement;
		}
	}

	private replaceId(id: string): string {
		if (id in ExistingObjectIds) {
			return ExistingObjectIds[id as keyof typeof ExistingObjectIds];
		}
		return id;
	}
}
